import fm from 'format-message';
import { styled } from '@activebrands/core-web/libs/styletron';
import { StyletronStyle } from '@activebrands/core-web/types/styletron';

interface ReturnIframeProps {
    width?: string | number;
    height?: string | number;
    src: string;
    title?: string;
    $style?: StyletronStyle;
}
const Wrapper = styled('div', {
    position: 'relative',
    maxHeight: '800px',
    display: 'flex',
    flexDirection: 'column',
});

const ReturnIframe = ({
    src = '',
    width = '590px',
    height = '620px',
    title = fm('Return request'),
    $style = {},
}: ReturnIframeProps) => (
    <Wrapper $style={{ width, height, ...$style }}>
        {title && <h1>{title}</h1>}
        <iframe id="returniframe" src={src} title={title} width="100%" style={{ border: 'none', flex: 1 }} />
    </Wrapper>
);

export default ReturnIframe;
